import { ObjectLanguagesParamInterface } from "@api/repositories/interfaces/ObjectDataParamsInterface";
import { MultiLangObjectModelInterface } from "../interfaces/common/MultiLangObjectModelInterface";

export class MultiLangObjectModel implements MultiLangObjectModelInterface  {
    $_multiLangFields: string[];

    /**
     * Returns multilang structure for update it in data base
     * @param languages
     * @param currentLang
     * @returns @type ObjectLanguagesParamInterface
     */
    getLanguages(languages: string[] | null, currentLang: string): ObjectLanguagesParamInterface | undefined {
        if (!languages) {
            return
        }

        const res: { [lang: string]: { [prop: string]: any } } = {};

        languages.forEach((lang) => {
            if (lang === currentLang) { return }

            this.$_multiLangFields.forEach((field) => {
                const value = (this as any)[`${field}.${lang}`] as any;
                if (value || typeof value === "string") {
                    if (!res[lang]) {
                        res[lang] = {}
                    }
                    res[lang][field] = value;
                }
            })
        })

        if (Object.keys(res).length) {
            return {
                ...res
            }
        }
    }

    /**
     * Returns no multilang fields from multi lang model for create it in databse
     * @param currentLang
     * @returns
     */
    getFields(currentLang: string) {
        let key: string;
        const res: any = {};

        for (key in this) {
            if (!key.includes(".")) {
                res[key] = (this as any)[key]
            }

            if (key.includes("." + currentLang)) {
                const keyWithoutLang = key.split(".")[0]
                res[keyWithoutLang] = (this as any)[key]
            }
        }

        return res;
    }
}